import { LOGIN_PATH, OIDC_CALLBACK_PATH } from "@airange/shared/oidc-routes";

export default [
  {
    path: LOGIN_PATH,
    layout: false,
    component: "./LoginPage",
  },
  {
    path: OIDC_CALLBACK_PATH,
    layout: false,
    component: "./OidcCallbackPage",
  },
  {
    path: "/",
    redirect: "/activities",
  },
  {
    path: "/members",
    name: "redblueMembers",
    icon: "team",
    access: "canAccessRedblueAdmin",
    component: "./MembersPage",
  },
  {
    path: "/schemes",
    name: "redblueSchemes",
    icon: "project",
    access: "canAccessRedblueAdmin",
    component: "./SchemesPage",
  },
  {
    path: "/schemes/:schemeCode/workbench",
    name: "redblueSchemeWorkbench",
    hideInMenu: true,
    access: "canAccessRedblueAdmin",
    component: "./SchemeWorkbench",
  },
  {
    path: "/schemes/:schemeCode",
    name: "redblueSchemeDetail",
    hideInMenu: true,
    access: "canAccessRedblueAdmin",
    component: "./SchemeDetailPage",
  },
  {
    path: "/activities",
    name: "redblueActivities",
    icon: "appstore",
    access: "canAccessRedblueAdmin",
    component: "./ActivitiesPage",
  },
  {
    path: "/activities/create",
    name: "redblueActivityCreate",
    hideInMenu: true,
    access: "canAccessRedblueAdmin",
    component: "./ActivityCreatePage",
  },
  {
    path: "/activities/:activityCode",
    name: "redblueActivityDetail",
    hideInMenu: true,
    access: "canAccessRedblueAdmin",
    component: "./ActivityDetailPage",
  },
  {
    path: "/acceptance",
    name: "redblueAcceptance",
    icon: "audit",
    access: "canAccessRedblueAcceptance",
    component: "./AcceptancePage",
  },
  {
    path: "/director",
    name: "redblueDirector",
    hideInMenu: true,
    icon: "dashboard",
    access: "canAccessRedblueAdmin",
    component: "./DirectorPage",
  },
  {
    path: "/judge",
    name: "redblueJudge",
    hideInMenu: true,
    icon: "safetyCertificate",
    access: "canAccessRedblueAdmin",
    component: "./JudgePage",
  },
  {
    path: "/review",
    name: "redblueReview",
    hideInMenu: true,
    icon: "eye",
    access: "canAccessRedblueAdmin",
    component: "./ReviewPage",
  },
  {
    path: "*",
    component: "./NotFoundPage",
  },
];
